import React from "react";
import Slider from "@mui/material/Slider";

export const PRICE_MIN = 0;
export const PRICE_MAX = 5000;

export const fmtPrice = (val: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(val);

interface Props {
  rangeMin: number;
  rangeMax: number;
  min: number;
  max: number;
  onMinChange: (v: number) => void;
  onMaxChange: (v: number) => void;
}

const PriceRange: React.FC<Props> = ({ rangeMin, rangeMax, min, max, onMinChange, onMaxChange }) => {
  const range = rangeMax - rangeMin || 1;
  const step = Math.max(1, Math.round(range / 100));

  const handleChange = (_: Event, value: number | number[]) => {
    if (!Array.isArray(value)) return;
    onMinChange(value[0]);
    onMaxChange(value[1]);
  };

  return (
    <div className="border border-white/30 rounded-xl px-4 pt-6 pb-2 [box-shadow:0_4px_12px_-4px_rgba(0,0,0,0.1),inset_4px_4px_14px_rgba(0,0,0,0.15),1px_1px_1px_rgba(255,255,255,0.14)]">
      <Slider
        value={[min, max]}
        onChange={handleChange}
        min={rangeMin}
        max={rangeMax}
        step={step}
        disableSwap
        sx={{
          color: "#05EE84",
          height: 8,
          "& .MuiSlider-thumb": {
            width: 18,
            height: 18,
            backgroundColor: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            "&:hover, &.Mui-focusVisible": { boxShadow: "0 0 0 6px rgba(5,238,132,0.25)" },
          },
          "& .MuiSlider-track": { border: "none" },
          "& .MuiSlider-rail": { backgroundColor: "rgba(255,255,255,0.25)" },
        }}
      />
      <div className="flex justify-between text-sm text-white -mt-1">
        <span>{fmtPrice(min)}</span>
        <span>{fmtPrice(max)}</span>
      </div>
    </div>
  );
};

export default PriceRange;
